const langPackLocalVersion = 90;export default langPackLocalVersion;
